import { buildChatPromptMessage } from "./messageFactory";

export const processHandler = ({
  history,
  addMessage,
  setIsUserInputEnabled,
  setConversationType,
  setProductArea,
  conversationType,
  productArea,
  createChatMessage,
  sessionId,
  setSessionId,
  setIsConversationEnded,
}) => {
  const processSelectConversationType = value => {
    if (value === "bug") {
      history.push("/form", { source: "chat", chatBotSessionId: sessionId });
    } else if (value == "question") {
      setIsUserInputEnabled(true);
    }
    setConversationType(value);
  };

  const processPostMessage = value => {
    addMessage("user", {
      content: value,
      buttons: [],
    });
    if (conversationType === "question") {
      setIsUserInputEnabled(false);
      createChatMessage({
        message: value,
        sessionId: sessionId,
        productArea: productArea,
      });
    }
  };

  return ({ event, value }) => {
    if (event === "select-conversation-type") {
      processSelectConversationType(value);
    } else if (event === "contact-support") {
      history.push("/form", { source: "chat", chatBotSessionId: sessionId });
    } else if (event === "start-chat") {
      addMessage("bot", buildChatPromptMessage());
      setSessionId(null);
      setProductArea(null);
      setConversationType(null);
      setIsUserInputEnabled(false);
      setIsConversationEnded(false);
    } else if (event == "post-message") {
      processPostMessage(value);
    }
  };
};
